module.exports = __webpack_public_path__ + "img/arrow_down_circle.93a92e4d.svg";